import { Colors } from 'styles';
import type { ColorsValueType } from 'styles/colors';
import { SlateSource, slateSource } from 'domains/reporter/RichTextEditor/core/slateSource';
import clone from 'ramda/es/clone';
import { walkSlateContent } from 'domains/reporter/RichTextEditor/utils';
import { Text } from '../../core';
import type { SlateContent } from '../../../Reporter/types';
import { DICTATION_ID_TEXT_MARK, DICTATION_INDEX_TEXT_MARK } from '../..';

export const ALLOWABLE_SOURCES_FOR_STYLING = new Set<string>([
  slateSource.ai.focusMode,
  slateSource.ai.impressionGenerator,
]);

export const getSourceTextColor = (source?: string | null): ColorsValueType => {
  switch (source) {
    case slateSource.ai.focusMode:
    case slateSource.ai.impressionGenerator:
      return Colors.aiPurple;
    //  We will begin marking text with these sources for https://sironamedical.atlassian.net/browse/RP-4053, but we are not yet committed to styling text based on them.
    // case slateSource.user.dictation:
    //   return Colors.orange5;
    // case slateSource.user.keyboard:
    //   return Colors.yellow5;
    default:
      return Colors.white;
  }
};

type AnnotateTextWithSourceOptions = {
  source?: SlateSource;
  dictationId?: string;
  dictationIndex?: number;
  overwriteSource?: boolean;
};

export const annotateTextWithSource = (
  content: SlateContent,
  options?: AnnotateTextWithSourceOptions
): SlateContent => {
  if (content == null) {
    return content;
  }
  const { source, overwriteSource, dictationId, dictationIndex } = options ?? {};

  const clonedContent = clone(content);
  walkSlateContent(
    (el) => {},
    (textNode) => {
      if (Text.isText(textNode)) {
        if (source && (overwriteSource || !textNode.source)) {
          textNode.source = source;
        }
        if (dictationId) {
          textNode[DICTATION_ID_TEXT_MARK] = dictationId;
          // A dictationIndex only makes sense if there is a dictationId.
          if (dictationIndex != null) {
            textNode[DICTATION_INDEX_TEXT_MARK] = dictationIndex;
          }
        }
      }
    }
  )(clonedContent);

  return clonedContent;
};
